import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const LawEnforcementIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });
  return (
    <Icon viewBox="0 0 200 200" {...rest} __css={styles}>
      <desc id="svgdescePolice">Law enforcement officers symbol</desc>
      <circle cx="100" cy="100" r="84.3" className="background" />
      <path
        d="m150.6 61-17.3-17.3a2.9 2.9 0 0 0-4.4.4c-4.1 6.3-8.4 9.5-12.7 9.6-5.4.2-10.8-5-14.2-9.4a3 3 0 0 0-2.3-1 3 3 0 0 0-2.3 1c-3.4 4.4-8.8 9.6-14.3 9.5-4.2-.2-8.5-3.4-12.6-9.7a2.9 2.9 0 0 0-2.1-1.3 3 3 0 0 0-2.4.9L48.8 60.9a2.9 2.9 0 0 0-.2 3.9C56 74 54 84.4 51.8 95.4c-4 20.2-8.6 43.1 47 62.3a2.8 2.8 0 0 0 .9.1 2.7 2.7 0 0 0 1-.1c55.5-19.2 51-42.1 46.9-62.3-2.2-11-4.3-21.3 3.2-30.6a2.9 2.9 0 0 0-.2-3.9z"
        className="accent"
      />
      <path
        d="M99.3 70.7a28.6 28.6 0 1 0 28.6 28.6 28.6 28.6 0 0 0-28.6-28.6z"
        className="background"
        style={{
          fill: variant === 'darkIconNoBackground' ? 'white' : undefined,
        }}
      />
      <path
        d="M96.9 74.8a24.6 24.6 0 0 0-20 14.6l13.8-2zm24.8 14.5A24.6 24.6 0 0 0 102.6 75l6.1 12.4zm-46.6 5.5a24.5 24.5 0 0 0 7.8 22.8l2.2-13zm41.3 22.1a24.5 24.5 0 0 0 7.5-17.6 25.8 25.8 0 0 0-.3-3.8l-9.3 9zm-28.3 4.3a24.5 24.5 0 0 0 22.8-.2l-11.2-6z"
        className="accent"
      />
      <path
        d="M125.4 131.5c-4 .7-7.2 1.5-10.3 2.3-5 1.3-9.6 2.5-15.4 2.5s-10.6-1.2-15.5-2.5c-3.1-.8-6.3-1.7-10.2-2.3l-1.8 5.6 9.8 2.6c6.8 1.8 11.2 3 17.7 3s10.8-1.2 17.6-3c2.8-.8 6-1.7 9.9-2.6zM99.6 59.7A58.5 58.5 0 0 0 85 61.5a42.8 42.8 0 0 0-11.3 4.6V73c6.6-4.8 16-7.7 26-7.7s19.5 2.9 26 7.7v-6.8a42.8 42.8 0 0 0-11.2-4.6 58.4 58.4 0 0 0-14.8-1.8z"
        className="background"
        style={{
          fill: variant === 'darkIconNoBackground' ? 'white' : undefined,
        }}
      />
    </Icon>
  );
};

export default LawEnforcementIcon;
